import { render, staticRenderFns } from "./Vite-sub.vue?vue&type=template&id=3b8cef63&scoped=true"
import script from "./Vite-sub.vue?vue&type=script&lang=js"
export * from "./Vite-sub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_cache-loader@4.1.0_webpack@4.44.2__css-load_2a1918961dfe1edf4ccf11a96faf4873/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8cef63",
  null
  
)

export default component.exports